module.exports = __webpack_public_path__ + "static/img/youshi3.7925ff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/digitalsoftware/youshi3.png
// module id = jXEn
// module chunks = 1